import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { getFabricatorList, getFabricators } from '../../Fabricators/FabricatorsActions';
import { clonePricingPresetsInto } from '../../../actions/pricingPresets';
import { errorBox_Show, messageBox_Show, showClonePricingPresetsIntoPopup } from '../../../actions/A_Popups';
import { store } from '../../../main';


const mapStateToProps = state => {
    const { fabricators } = state;

    return {
        searchKeyword: fabricators.searchKeyword,
        page: fabricators.data.page
    }
};

const mapDispatchToProps = dispatch => ({
    showClonePricingPresetsIntoPopup: show => dispatch(showClonePricingPresetsIntoPopup(show)),
    clonePricingPresetsInto: (data) => dispatch(clonePricingPresetsInto(data)),
    getFabricators: (page, limit, searchKeyword) => dispatch(getFabricators(page, limit, searchKeyword))
});

class ClonePricingPresetsIntoClass extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchKeyword: null,
            fabricators: [],
            loading: true
        }
    }

    componentDidMount() {
        getFabricatorList().then(fabs => {
            let fabricators = _.map(fabs, f => ({
                text: f.name,
                value: f.id,
                checked: false
            }));
            let selected = _.first(fabricators);
            let selectedValue = null;
            if (selected && selected.value) {
                selectedValue = selected.value;
            }
            this.setState({ fabricators, selectedFabricator: selectedValue, loading: false });
        });
    }

    handleCloneInto = () => {
        if (this.state.loading)
            return;
        this.setState({ loading: true }, async () => {
            const selectedFabricatorIds = this.state.fabricators.filter(x => x.checked).map(x => x.value);
            var response = await this.props.clonePricingPresetsInto(selectedFabricatorIds);
            this.setState({ loading: false });
            if (response) {
                store.dispatch(messageBox_Show(true, "system", "Success", "Pricing Presets were successfully cloned into selected Fabricators.",
                    [{
                        text: 'Ok',
                        onClick: () => {
                            store.dispatch(messageBox_Show(false));
                        }
                    }]));
            }
            else {
                store.dispatch(errorBox_Show({
                    title: 'Error',
                    text: 'Something went wrong with cloning Pricing Presets. Please contact support.',
                    rightButtonText: 'OK',
                    isRightButtonVisible: true
                }))
            }

        });
    }

    handleCancel = () => {
        this.props.showClonePricingPresetsIntoPopup(false);
        this.props.getFabricators(this.props.page, 50, this.props.searchKeyword);
    }

    handleSearchInput = (e) => {
        this.setState({ ...this.state, searchKeyword: e.target.value })
    }

    handleFabricatorCheckbox = (e) => {
        const fabricatorId = Number(e.target.id.replace("fabricator_", ''));
        const updatedFabricators = this.state.fabricators.map(f => {
            if (f.value === fabricatorId)
                f.checked = e.target.checked
            return f;
        });
        this.setState({ ...this.state, fabricators: updatedFabricators });
    }

    render() {
        const fabricators = this.state.searchKeyword
            ? this.state.fabricators.filter(f => f.text.toLowerCase().includes(this.state.searchKeyword.toLowerCase()))
            : this.state.fabricators;

        const styles = {
            width: "100%",
            height: "100%",
            margin: 0,
            padding: 0,
            position: "absolute",
            zIndex: "2000"
        }

        return <div className="export-overlay-popup">
            <div className="export-overlay-popup-header">
                <div className="export-overlay-popup-header--title">
                    Clone Pricing Presets into
                </div>
                <div className="export-overlay-popup-header--control">
                    <div className="export-overlay-popup-header--control-close">
                    </div>
                </div>
            </div>
            <div className="export-overlay-popup-body">
                {this.state.loading
                    ? <div style={styles}>
                        <div className="ui-loader" />
                    </div>
                    : (<div>
                        <div>
                            <input type="text"
                                onChange={this.handleSearchInput}
                                className="ui-input ui-input--blue ui-input--new ass-field__input"
                                placeholder="Enter Fabricator Name" />
                        </div>
                        <ul className="ui-list export-fabricators-list">
                            {
                                fabricators.map((f) => {
                                    return (
                                        <li key={f.value}>
                                            <div className="feature-inclusion-popup-row">
                                                <div className="ui-checkbox2">
                                                    <input type="checkbox" id={`fabricator_${f.value}`} onChange={this.handleFabricatorCheckbox} />
                                                    <label htmlFor={`fabricator_${f.value}`}>{f.text}</label>
                                                </div>
                                            </div>
                                        </li>)
                                })
                            }
                        </ul>
                    </div>)
                }

                <div className="export-overlay-popup-footer">
                    <div className="ui-popup-footer__right">
                        <button className="ui-button ui-button--red" onClick={this.handleCancel}><span className="ui-button-text ui-button--uppercase">Cancel</span></button>
                        <button className="ui-button ui-button--blue" onClick={this.handleCloneInto}><span className="ui-button-text ui-button--uppercase">Clone Into</span></button>
                    </div>
                </div>
            </div>
        </div>
    }
}

ClonePricingPresetsIntoClass.propTypes = {

};

const connector = connect(mapStateToProps, mapDispatchToProps);
const ClonePricingPresetsIntoPopup = connector(ClonePricingPresetsIntoClass);

export default ClonePricingPresetsIntoPopup;
export { ClonePricingPresetsIntoPopup };

